import React from 'react';
import styles from './styles.module.scss';
import { Button, TextField } from '@mui/material';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { routes } from '../../../assets/routes';
import { useTranslation } from '../../../i18n/LanguageProvider';

const PhoneNumber = ({ onSubmitPhone, loading }) => {
  const { t } = useTranslation();
  const [phoneNumber, setPhoneNumber] = useState('');
  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmitPhone(phoneNumber);
  };

  return (
    <form onSubmit={handleSubmit}>
      <p>{t('auth.enterPhone')}</p>
      <TextField
        className={styles.formItem}
        fullWidth
        label={t('auth.phone')}
        id="phone"
        autoComplete="tel"
        type="tel"
        ltr
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
      />

      <Button
        fullWidth
        variant="contained"
        className={styles.formItem}
        type="submit"
        disabled={loading}
      >
        {t('auth.confirmPhone')}
      </Button>
      <Button
        fullWidth
        variant="text"
        className={styles.formItem}
        disabled={loading}
        onClick={() => history.push(routes.LOGIN)}
      >
        {t('common.cancel')}
      </Button>
    </form>
  );
};

PhoneNumber.propTypes = {
  onSubmitPhone: PropTypes.func,
  loading: PropTypes.bool
};

export default PhoneNumber;
